import { Button } from '@/components/ui/button'
import { Sparkles, ArrowRight } from 'lucide-react'

interface CTABannerProps {
  title: string
  description: string
  buttonText: string
  buttonLink: string
  variant?: 'default' | 'secondary'
}

const CTABanner = ({
  title,
  description,
  buttonText,
  buttonLink,
  variant = 'default',
}: CTABannerProps) => {
  return (
    <div className="bg-card border border-border/50 rounded-2xl p-8 md:p-10 my-16 shadow-sm">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-start gap-5 flex-1">
          <div className="p-4 rounded-full bg-gold/15 border border-gold/20">
            <Sparkles className="h-7 w-7 text-gold" />
          </div>
          <div>
            <h3 className="font-serif text-2xl md:text-3xl font-semibold mb-3 text-foreground tracking-tight leading-tight">
              {title}
            </h3>
            <p className="text-base text-muted-foreground leading-relaxed">
              {description}
            </p>
          </div>
        </div>
        <Button
          size="lg"
          asChild
          className="gap-2 whitespace-nowrap bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-8"
        >
          <a href={buttonLink}>
            {buttonText}
            <ArrowRight className="h-4 w-4" />
          </a>
        </Button>
      </div>
    </div>
  )
}

export default CTABanner
